import Quill from "quill"

////////////////////////////////////////////////////////////////////////////////

const BlockEmbed = Quill.import('blots/embed');

class PublicationBlot extends BlockEmbed {

    static blotName = 'publication';
    static tagName = 'span';
    static className = 'ql-blot-publication';

    static create(data: any) {
        if (data.url) {
            const node: any = super.create();

            const a = document.createElement("a");
            a.setAttribute("target", "_blank");
            a.setAttribute("href", data.url);
            //a.setAttribute("contenteditable", "false");

            a.innerHTML = data.title;

            //node.appendChild(icon);
            node.appendChild(a);

            return node;
        }
        return data;
    }

    static value(domNode: any) {
        return domNode;
    }
}

Quill.register(PublicationBlot);
